import { createCustomEvent } from "../../shared/helpers";

export default class extends Controller {

  overlayClick(event) {
    event && event.preventDefault();
    document.dispatchEvent(createCustomEvent("overlay:click", this.element))
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/via-modal-overlay-controller.js